import React from 'react'
import { Header } from "../Header";
import { Footer } from "../Footer";
import line from "../../assests/Group 1870 line2.png";

import lwr2 from "../../assests/lwrs5.png";
import { useEffect } from 'react';



function OurStrategy() {
  useEffect(() => {
    // Set the scroll position when the component mounts
    window.scrollTo(0, 0); // Adjust the '500' value as needed
  }, []);
    return (
        <>
            <Header />
            <section id='ourmission' style={{ minHeight: "100vh" }}>
            <div className="container mt-5">
          <div className="row mt-5">
            <div className="col-md-12 text-center mt-5">
              <h3 className="fw-bold text-dark mb-0">OUR STRATEGY</h3>
              <img src={line} className="img-fluid " />
            </div>
          </div>
          <div className="row d-flex justify-content-center align-items-center mt-4">
            <div className="col md-8 ">
              <h4 className="fw-bold text-danger"></h4>
              <p className="text-dark " style={{ fontSize: "20px" }}>
              Love Without Reason's impact is because of Susan and Santhosh's new holistic strategy of rendering services for cleft surgeries in developing countries.


              </p>

              <h4 className="fw-bold text-danger"></h4>
              <p className="text-dark" style={{ fontSize: "20px" }}>
              The Love Without Reason holistic services system that includes speech therapy and orthodontia gives these children a full array of opportunities to thrive and become productive citizens in these countries.


              </p>

              <h4 className="fw-bold text-danger"></h4>
              <p className="text-dark" style={{ fontSize: "20px" }}>
              Each Love Without Reason child no longer is stigmatized as "cursed", abandoned or even killed.


              </p>
              <p className="text-dark" style={{ fontSize: "20px" }}>
              Families are being educated and provided with resources to help them protect their children from organ harvesters who traffick human organs for obscene profits.
              </p>
            </div>
            <div className="col-md-4 text-start">
              <img className=" img-fluid mb-2 " src={lwr2} />
            </div>
          </div>
        </div>
      </section>
            <Footer />

        </>
    )
}

export default OurStrategy

